/* What a CONFIRM adds to `shared/ui/dialogSurface.module.css`, and nothing else.
 *
 * The backdrop, the popup, the title, the description, the actions row and the five answer
 * treatments are that file's, imported alongside this one — the device `ActDialog` already used and
 * `SessionCardMenu` uses for `MenuSurface`. Only the two blocks a confirm has of its own live here.
 *
 * The popup's WIDTH is the caller's, handed to the surface through `--dialog-w`; the surface reads
 * it and never declares one, so nothing about this box is written on two sides. */

/* A description whose line breaks carry meaning (`multiline`): a list, one entry per line. */
.lines {
  white-space: pre-line;
}

/* The name the act is about, on its own line and in the primary ink — it is the one thing on this
 * card the trainer has to recognise before answering. Inside the description so it is announced
 * with it; `display: block` because a `<span>` in flowing text would run into the sentence. */
.subject {
  display: block;
  margin-bottom: var(--space-1);
  font-size: var(--fs-exercise);
  font-weight: var(--fw-extrabold);
  letter-spacing: var(--ls-heading);
  color: var(--text);
}

/* Why the THIRD answer cannot act.
 *
 * Drawn rather than left on a `title`: the sentence it repeats — „Ankieta potrzebuje nazwy." — is
 * rendered under the save button on the screen BEHIND this card, which the scrim has just put out
 * of reach. A dialog offering an answer that does nothing, with the reason invisible, is the one
 * shape worse than not offering it. */
.refusal {
  font-size: var(--fs-micro);
  font-weight: var(--fw-medium);
  line-height: var(--lh-note);
  color: var(--text-2);
}

